import { render, staticRenderFns } from "./WarningPage.vue?vue&type=template&id=094ca448&scoped=true&"
import script from "./WarningPage.vue?vue&type=script&lang=js&"
export * from "./WarningPage.vue?vue&type=script&lang=js&"
import style0 from "./WarningPage.vue?vue&type=style&index=0&id=094ca448&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094ca448",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VIcon,VRow})
